var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "GetStartedLayout",
    { attrs: { errors: _vm.errors, title: "Create an Account" } },
    [
      _c(
        "v-col",
        {
          staticClass: "white--text text-center",
          attrs: { cols: "12", tag: "h1" },
        },
        [
          _c(
            "v-card",
            {
              staticClass: "soli-round mx-auto",
              attrs: { "max-width": "450" },
            },
            [
              _c(
                "v-container",
                { staticClass: "pa-5" },
                [
                  _c(
                    "v-container",
                    { staticStyle: { "max-width": "375px" } },
                    [
                      _c("GoogleSignIn", {
                        attrs: {
                          errors: _vm.errors,
                          register: "",
                          divider: "",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "mx-auto",
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.submit.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("NewEmail", {
                            attrs: {
                              errors: _vm.errors.email,
                              hideDetails: "",
                              autofocus: "",
                            },
                            on: {
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.$refs.password.$refs.password.focus()
                              },
                            },
                            model: {
                              value: _vm.form.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "email", $$v)
                              },
                              expression: "form.email",
                            },
                          }),
                          _vm._v(" "),
                          _c("NewPassword", {
                            ref: "password",
                            staticClass: "pt-3",
                            attrs: {
                              errors: _vm.errors.password,
                              hideDetails: "",
                            },
                            on: {
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.submit.apply(null, arguments)
                              },
                            },
                            model: {
                              value: _vm.form.password,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "password", $$v)
                              },
                              expression: "form.password",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.errors
                    ? _c("p", { staticClass: "caption red--text mx-auto" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(Object.values(_vm.errors)[0]) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-container",
                    { staticClass: "mt-2" },
                    [
                      _c("SoliBtn", {
                        attrs: {
                          type: "submit",
                          text: "Continue",
                          loading: _vm.loading,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.submit()
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }